import { LoanEstimate as ProductDetailLoanEstimate } from '@/components/ProductDetail/ProductDetail';

export type LoanEstimateProps = {
  productId: string;
  hideHero?: boolean;
};

export const LoanEstimate = ({ productId, hideHero }: LoanEstimateProps) => {
  return (
    <ProductDetailLoanEstimate productId={productId} hideHero={hideHero} />
  );
};
